import { render, staticRenderFns } from "./SettingWordModal.vue?vue&type=template&id=6ef279a0&scoped=true"
import script from "./SettingWordModal.vue?vue&type=script&lang=js"
export * from "./SettingWordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef279a0",
  null
  
)

export default component.exports